import React from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { SOURCECLEAR_COMPONENTS } from '~/constants/ModelConstants';
import vcFavicon from '~/vcfavicon.ico';

const RegistryHelmet: React.SFC<RegistryHelmetProps> = props => {
  const helmetData = {
    title: `Veracode ${
      SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.name
    } - Open-Source Libraries and Vulnerabilities`,
    titleTemplate: '%s - Veracode',
    favicon: vcFavicon,
  };
  return (
    <Helmet title={helmetData.title} titleTemplate={helmetData.titleTemplate}>
      <link rel="icon" href={helmetData.favicon} sizes="32x32" />
    </Helmet>
  );
};

export default RegistryHelmet;
